import { useTranslation } from "react-i18next";

export function T({
  tKey,
  args,
}: {
  tKey: string;
  args?: Record<string, string>;
}) {
  const { t } = useTranslation();
  return <>{t(tKey, args)}</>;
}
